import {
  Box,
  FormControl,
  CardContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Card,
  TextField,
  Button,
  Paper,
  Grid,
  Checkbox,
  CircularProgress,
} from "@mui/material"
import { useState, useEffect } from "react"
import { Trans, useTranslation } from "react-i18next"
import { BooleanUtils } from "../utils/BooleanUtils"
import { initialState } from "./InitialStates/CommunicationRenseignementInitialState"
import { DatePicker } from "@mui/x-date-pickers"
import axios from "axios"
import Turnstile, { useTurnstile } from "react-turnstile"
import ProvinceDropdown from "./SecondaryForms/ProvincesTerritoiresDropdown"
import "./CSS/colorMessages.css"
import appendObjectToFormData from '../utils/useFormData'
import { useNavigate } from "react-router-dom"

const FormulaireCommunicationRenseignement = () => {
  let navigate = useNavigate()
  const [communication, setCommunication] = useState(initialState)
  const [reCaptchaRequest, setReCaptcha] = useState({ reCaptchaToken: "", remoteip: null })
  const [successForm, setSuccessForm] = useState("")
  const [errorSubmission, setErrorSubmission] = useState("")
  const [errorStatut, setErrorStatut] = useState("")
  const [errorTelephone1, setErrorTelephone1] = useState("")
  const [errorTelephone2, setErrorTelephone2] = useState("")
  const [errorCourriel, setErrorCourriel] = useState("")
  const [errorCodePostal, setErrorCodePostal] = useState("")
  const [errorAdresse, setErrorAdresse] = useState("")
  const [errorRenseignement, setErrorRenseignement] = useState("")
  const [errorRenseignementAutreOrganisme, setErrorRenseignementAutreOrganisme] = useState("")
  const [errorDateTransmission, setErrorDateTransmission] = useState("")
  const [errorNomAutreOrganisme, setErrorNomAutreOrganisme] = useState("")
  const [errorAttestation, setErrorAttestation] = useState("")
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const decodeHtmlEntities = (text: string | null = ''): string => {
    return text 
      ? text
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      : '';
  };
  const goToConfirmation = () => {
    return navigate("/confirmation")
  }

  useEffect(() => {
    document.title = "Communication renseignement"
  }, [])

  const handleOuiNonQuestionChange = (event: any) => {
    const { name, value } = event.target
    setCommunication((prevState) => {
      return {
        ...prevState,
        [name]: BooleanUtils.fromStringToBoolean(value),
      }
    })
  }
  const handleOnChange = (event: any) => {
    const { name, value } = event.target
    setCommunication((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }
  const handleProvinceTerritoireSelect = (provinceTerritoire: string) => {
    var comm = communication
    setCommunication((prevState) => ({
      ...prevState,
      provinceOuTerritoire: provinceTerritoire,
    }))
  }
  const handleOuiNonCheckboxChange = (event: any) => {
    const name = event.target.name
    setCommunication((prevState) => {
      return {
        ...prevState,
        [name]: event.target.checked,
      }
    })
  }
  const onChangeDateTransmission = (value: Date | null) => {
    let dateValue = value
    let todayDate = new Date()
    if (dateValue > todayDate) {
      setErrorDateTransmission(t("messagesUtilisateurs.lblDateFuture"))
    }
    else {
      setErrorDateTransmission("")
    }
    setCommunication((prevState) => {
      return {
        ...prevState,
        dateTransmissionAutreOrganisme: value.toISOString(),
      }
    })
  }

  const handleAttestationOnChange = (event: any) => {
    setCommunication((prevState) => {
      return {
        ...prevState,
        ['attestation']: !communication.attestation,
      }
    })
  }

  const TurnstileWidget = () => {
    const turnstile = useTurnstile()
    return (
      <Turnstile
        sitekey="0x4AAAAAAATUkYKisAyqVMcx"
        onVerify={async (token) => {
          const res = await axios.get("https://api.ipify.org/?format=json")
          setReCaptcha({ reCaptchaToken: token, remoteip: res.data.ip })
        }}
      />
    )
  }

  useEffect(() => {
    handleErrors()
  }, [communication])

  const handleErrors = () => {
    if (errorStatut === t("messagesUtilisateurs.lblChampRequis") && communication.statut !== null) {
      setErrorStatut("")
    }
    if (errorRenseignement === t("messagesUtilisateurs.lblChampRequis") && communication.renseignements !== "") {
      setErrorRenseignement("")
    }
    if (errorRenseignementAutreOrganisme === t("messagesUtilisateurs.lblChampRequis") && communication.renseignementsTransmisAutreOrganisme !== null) {
      setErrorRenseignementAutreOrganisme("")
    }
    if (errorNomAutreOrganisme === t("messagesUtilisateurs.lblChampRequis") && communication.autreOrganisme !== "") {
      setErrorNomAutreOrganisme("")
    }
    if (errorAttestation === t("messagesUtilisateurs.lblChampRequis") && communication.attestation) {
      setErrorAttestation("")
    }
  }

  const handleFormatErrors = (fieldName: string) => {
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    var regexAdresse = /^\s*\S+(?:\s+\S+){2}/
    var regexCodePostal =
      /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
    if (fieldName === "adresse") {
      if (
        communication.adresse !== "" &&
        !regexAdresse.test(communication.adresse)
      ) {
        setErrorAdresse(
          t("messagesUtilisateurs.communicationRenseignement.lblFormatAdresse")
        )
      } else setErrorAdresse("")
    }
    else if (fieldName === "courriel") {
      if (
        communication.courriel !== "" &&
        !regexCourriel.test(communication.courriel)
      ) {
        setErrorCourriel(
          t(
            "messagesUtilisateurs.communicationRenseignement.lblFormatCourrielInvalide"
          )
        )
      } else setErrorCourriel("")
    }
    else if (fieldName === "telephone1") {
      if (
        communication.telephone1 !== "" &&
        !regexTelephone.test(communication.telephone1)
      ) {
        setErrorTelephone1(
          t(
            "messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"
          )
        )
      } else setErrorTelephone1("")
    }
    else if (fieldName === "telephone2") {
      if (
        communication.telephone2 !== "" &&
        !regexTelephone.test(communication.telephone2)
      ) {
        setErrorTelephone2(
          t(
            "messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"
          )
        )
      } else setErrorTelephone2("")
    }
    else if (fieldName === "codePostal") {
      if (
        communication.codePostal !== "" &&
        !regexCodePostal.test(communication.codePostal)
      ) {
        setErrorCodePostal(
          t("messagesUtilisateurs.communicationRenseignement.lblFormatCodePostal")
        )
      } else setErrorCodePostal("")
    }
  }

  const handleSubmit = () => {
    let error = false
    if (communication.statut === null) {
      setErrorStatut(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorStatut("")
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    var regexAdresse = /^\s*\S+(?:\s+\S+){2}/
    var regexCodePostal =
      /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
    if (
      communication.courriel !== "" &&
      !regexCourriel.test(communication.courriel)
    ) {
      setErrorCourriel(
        t(
          "messagesUtilisateurs.communicationRenseignement.lblFormatCourrielInvalide"
        )
      )
      error = true
    } else setErrorCourriel("")
    if (
      communication.telephone1 !== "" &&
      !regexTelephone.test(communication.telephone1)
    ) {
      setErrorTelephone1(
        t(
          "messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"
        )
      )
      error = true
    } else setErrorTelephone1("")
    if (
      communication.telephone2 !== "" &&
      !regexTelephone.test(communication.telephone2)
    ) {
      setErrorTelephone2(
        t(
          "messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"
        )
      )
      error = true
    } else setErrorTelephone2("")
    if (
      communication.codePostal !== "" &&
      !regexCodePostal.test(communication.codePostal)
    ) {
      setErrorCodePostal(
        t("messagesUtilisateurs.communicationRenseignement.lblFormatCodePostal")
      )
      error = true
    } else setErrorCodePostal("")
    if (
      communication.adresse !== "" &&
      !regexAdresse.test(communication.adresse)
    ) {
      setErrorAdresse(
        t("messagesUtilisateurs.communicationRenseignement.lblFormatAdresse")
      )
      error = true
    } else setErrorAdresse("")
    if (communication.renseignements === "") {
      setErrorRenseignement(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorRenseignement("")
    if (communication.renseignementsTransmisAutreOrganisme === null) {
      setErrorRenseignementAutreOrganisme(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorRenseignementAutreOrganisme("")
    if (communication.renseignementsTransmisAutreOrganisme) {
      if (communication.autreOrganisme === "") {
        setErrorNomAutreOrganisme(t("messagesUtilisateurs.lblChampRequis"))
        error = true
      }
      else setErrorNomAutreOrganisme("")
    }
    if (communication.dateTransmissionAutreOrganisme != null) {
      let dateValue = new Date(communication.dateTransmissionAutreOrganisme)
      let todayDate = new Date()
      if (dateValue > todayDate) {
        setErrorDateTransmission(t("messagesUtilisateurs.lblDateFuture"))
        error = true
      }
      else {
        setErrorDateTransmission("")
      }
    }
    if (!communication.attestation) {
      setErrorAttestation(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorAttestation("")
    if (error) setErrorSubmission(t("messagesUtilisateurs.lblErreurChampsFormulaire"))
    if (!error) {
      const formData = new FormData()
      appendObjectToFormData(formData, 'communicationForm', communication)
      appendObjectToFormData(formData, 'reCaptchaRequest', reCaptchaRequest)
      formData.append('nomFormulaire', 'CommunicationRenseignements')
      formData.append('nomEntrepriseOuIndividu', communication.entreprisesConcernees)
      formData.append('adresseCourriel', communication.courriel)

      setLoading(true)
      setSaved(true)
      axios
        .post(
          process.env.REACT_APP_API_URL + "/v1/TraiterFormulaires/upload",
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
        )
        .then((response) => {
          setSaved(true)
          setSuccessForm(t("messagesUtilisateurs.lblSuccesSoumission"))
          setErrorSubmission("")
          goToConfirmation()
        })
        .catch((error) => {
          setSaved(false)
          setSuccessForm("")
          setErrorSubmission(
            t("messagesUtilisateurs.lblErreurEnvoiFormulaire")
          )
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        })
    }
    else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }

  const getChampsInformationsContact = (
    errorTelephone1: string,
    errorTelephone2: string,
    errorCourriel: string,
    errorCodePostal: string,
  ): JSX.Element | null => {
    return (
      <FormControl fullWidth>
        <div className="form-text-label">
          <Trans>
            {t("formulaireCommunicationRenseignement.coordonnees.lblSection")}
          </Trans>
        </div>

        <Grid container>
          <Grid item xs={6}>
            <FormControl className="width-98" >
              <TextField
                label={<Trans>{t("formulaireContact.lblChampNom")}</Trans>}
                name="nom"
                value={decodeHtmlEntities(communication.nom || '')}
                onChange={handleOnChange}
                fullWidth
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth >
              <TextField
                label={<Trans>{t("formulaireContact.lblChampPrenom")}</Trans>}
                name="prenom"
                value={decodeHtmlEntities(communication.prenom || '')}
                onChange={handleOnChange}
                fullWidth
              />
            </FormControl>
          </Grid>
        </Grid>
        <FormControl fullWidth >
          <TextField
            label={
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampAdresse"
                )}
              </Trans>
            }
            name="adresse"
            value={decodeHtmlEntities(communication.adresse || '')}
            onChange={handleOnChange}
            onBlur={() => handleFormatErrors("adresse")}
            aria-describedby="error-adresse"
            style={{ backgroundColor: errorAdresse ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
          />
        </FormControl>
        {errorAdresse && (
          <strong id="error-adresse" role="alert" className="error">
            <Trans>{errorAdresse}</Trans>
          </strong>
        )}
        <Grid container>
          <Grid item xs={4}>
            <FormControl className="width-98" >
              <TextField
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampVille"
                    )}
                  </Trans>
                }
                name="ville"
                value={decodeHtmlEntities(communication.ville  || '')}
                onChange={handleOnChange}
                fullWidth
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl className="width-98" >
              <ProvinceDropdown
                onChange={handleProvinceTerritoireSelect} />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth >
              <TextField
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampCodePostal"
                    )}
                  </Trans>
                }
                name="codePostal"
                value={decodeHtmlEntities(communication.codePostal || '')}
                onChange={handleOnChange}
                onBlur={() => handleFormatErrors("codePostal")}
                fullWidth
                aria-describedby="error-code-postal"
                style={{ backgroundColor: errorCodePostal ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
            </FormControl>
            {errorCodePostal && (
              <strong id="error-code-postal" role="alert" className="error">
                <Trans>{errorCodePostal}</Trans>
              </strong>
            )}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6}>
            <FormControl className="width-98" >
              <TextField
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampEmployeur"
                    )}
                  </Trans>
                }
                name="employeur"
                value={decodeHtmlEntities(communication.employeur || '')}
                onChange={handleOnChange}

                fullWidth
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth >
              <TextField
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampFonction"
                    )}
                  </Trans>
                }
                name="fonction"
                value={decodeHtmlEntities(communication.fonction || '')}
                onChange={handleOnChange}
                fullWidth
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6}>
            <FormControl className="width-98" >
              <TextField
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampTelephone1"
                    )}
                  </Trans>
                }
                name="telephone1"
                value={decodeHtmlEntities(communication.telephone1 || '')}
                onChange={handleOnChange}
                onBlur={() => handleFormatErrors("telephone1")}
                fullWidth
                aria-describedby="error-telephone1"
                style={{ backgroundColor: errorTelephone1 ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
            </FormControl>
            <div>
              {errorTelephone1 && (
                <strong id="error-telephone1" role="alert" className="error">
                  <Trans>{errorTelephone1}</Trans>
                </strong>
              )}
            </div>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth >
              <TextField
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblChampTelephone2"
                    )}
                  </Trans>
                }
                name="telephone2"
                value={decodeHtmlEntities(communication.telephone2 || '')}
                onChange={handleOnChange}
                onBlur={() => handleFormatErrors("telephone2")}
                fullWidth
                aria-describedby="error-telephone2"
                style={{ backgroundColor: errorTelephone2 ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
            </FormControl>
            {errorTelephone2 && (
              <strong id="error-telephone2" role="alert" className="error">
                <Trans>{errorTelephone2}</Trans>
              </strong>
            )}
          </Grid>
        </Grid>
        <FormControl fullWidth >
          <TextField
            label={<Trans>{t("formulaireContact.lblChampCourriel")}</Trans>}
            name="courriel"
            value={decodeHtmlEntities(communication.courriel || '')}
            onChange={handleOnChange}
            onBlur={() => handleFormatErrors("courriel")}
            aria-describedby="error-courriel"
            style={{ backgroundColor: errorCourriel ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
          />
        </FormControl>
        {errorCourriel && (
          <strong id="error-courriel" role="alert" className="error">
            <Trans>{errorCourriel}</Trans>
          </strong>
        )}
      </FormControl>
    )
  }

  const getChampsAutresInformationsContact = (
  ): JSX.Element | null => {
    return (
      <FormControl>
        <FormControl>
          <div className="form-text-label">
            <Trans>
              {t(
                "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblSectionModePrivilegie"
              )}
            </Trans>
          </div>
        </FormControl>
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                name="telephone1ModeContactPrivilegie"
                checked={communication.telephone1ModeContactPrivilegie}
                onChange={handleOuiNonCheckboxChange}
              />
            }
            label={
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblModeTelephone1"
                )}
              </Trans>
            }
            labelPlacement="start"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="telephone2ModeContactPrivilegie"
                checked={communication.telephone2ModeContactPrivilegie}
                onChange={handleOuiNonCheckboxChange}
              />
            }
            label={
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblModeTelephone2"
                )}
              </Trans>
            }
            labelPlacement="start"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="courrielModeContactPrivilegie"
                checked={communication.courrielModeContactPrivilegie}
                onChange={handleOuiNonCheckboxChange}
              />
            }
            label={
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblModeCourriel"
                )}
              </Trans>
            }
            labelPlacement="start"
          />
        </FormControl>
        <div className="form-text-label">
          <Trans>
            {t(
              "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblSectionLangue"
            )}
          </Trans>
        </div>
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                name="francais"
                checked={communication.francais}
                onChange={handleOuiNonCheckboxChange}
              />
            }
            label={
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblFrancais"
                )}
              </Trans>
            }
            labelPlacement="start"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="anglais"
                checked={communication.anglais}
                onChange={handleOuiNonCheckboxChange}
              />
            }
            label={
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblAnglais"
                )}
              </Trans>
            }
            labelPlacement="start"
          />
          <TextField
            label={
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.coordonnees.informationsContact.lblAutre"
                )}
              </Trans>
            }
            name="autreLangue"
            value={decodeHtmlEntities(communication.autreLangue || '')}
            onChange={handleOnChange}

          />
        </FormControl>
      </FormControl>
    )
  }

  const getChampAutreOrganisme = (
    afficherChamps: boolean
  ): JSX.Element | null => {
    return afficherChamps ? (
      <div className="form-div-no-margin">
        <FormControl fullWidth >
          <TextField
            label="Précisez l'organisme"
            name="autreOrganisme"
            title="Précisez l'organisme"
            value={decodeHtmlEntities(communication.autreOrganisme || '')}
            onChange={handleOnChange}
            required
            aria-describedby="error-nom-autre-organisme"
            style={{ backgroundColor: errorNomAutreOrganisme ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
          />
        </FormControl>
        {errorNomAutreOrganisme && (
          <strong id="error-nom-autre-organisme" role="alert" className="error">
            <Trans>{errorNomAutreOrganisme}</Trans>
          </strong>
        )}
      </div>
    ) : null
  }


  return (
    <>
      <Card className="card" sx={{ minWidth: 275 }}>
        <CardContent>
          <Box
            component="form"
            sx={{
              "& > :not(style)": { m: 1 },
            }}
          >
            {successForm && (
              <strong id="success" role="alert" className="success">
                <Trans>{successForm}</Trans>
              </strong>
            )}

            {errorSubmission && (
              <strong id="error-submission" role="alert" className="error">
                <Trans>{errorSubmission}</Trans>
              </strong>
            )}
            <div className="form-section-label">
              <Trans>{t("formulaireCommunicationRenseignement.lblPage")}</Trans>
            </div>
            <FormControl fullWidth>
              <div className="form-text-label">
                <Trans>
                  {t(
                    "formulaireCommunicationRenseignement.coordonnees.lblStatut"
                  )}
                </Trans>
              </div>
              <RadioGroup
                row
                aria-labelledby="radio-statut-group-label"
                name="statut"
                onChange={handleOnChange}
                style={{ backgroundColor: errorStatut ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              >
                <FormControlLabel
                  value="citoyen"
                  control={<Radio />}
                  label={t(
                    "formulaireCommunicationRenseignement.coordonnees.statut.lblCitoyen"
                  )}
                />
                <FormControlLabel
                  value="titulaireChargePublique"
                  control={<Radio />}
                  label={t(
                    "formulaireCommunicationRenseignement.coordonnees.statut.lblTitulaireChargePublique"
                  )}
                />
                <FormControlLabel
                  value="fournisseurEntrepreneurSousTraitant"
                  control={<Radio />}
                  label={t(
                    "formulaireCommunicationRenseignement.coordonnees.statut.lblFournisseurEntrepreneurSousTraitant"
                  )}
                />
                <FormControlLabel
                  value="eluOuMembreCabinetElu"
                  control={<Radio />}
                  label={t(
                    "formulaireCommunicationRenseignement.coordonnees.statut.lblEluOuMembreCabinetElu"
                  )}
                />
                <FormControlLabel
                  value="autre"
                  control={<Radio />}
                  label={t(
                    "formulaireCommunicationRenseignement.coordonnees.statut.lblAutre"
                  )}
                  aria-describedby="error-statut"
                />
              </RadioGroup>
            </FormControl>

            {errorStatut && (
              <strong id="error-statut" role="alert" className="error">
                <Trans>{errorStatut}</Trans>
              </strong>
            )}

            <div className="alert">
              <p>
                <Trans>
                  {t(
                    "formulaireCommunicationRenseignement.coordonnees.lblMessageUtilisateur"
                  )}
                </Trans>
              </p>
            </div>

            {getChampsInformationsContact(
              errorTelephone1,
              errorTelephone2,
              errorCourriel,
              errorCodePostal,
            )}
            {getChampsAutresInformationsContact()}

            <div className="form-text-label">
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.informationsNominatives.lblSection"
                )}
              </Trans>
            </div>
            <FormControl fullWidth>
              <TextField
                name="organismesConcernes"
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.informationsNominatives.lblOrganismesConcernes"
                    )}
                  </Trans>
                }
                multiline
                rows={4}
                onChange={handleOnChange}
                value={decodeHtmlEntities(communication.organismesConcernes || '')}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                name="entreprisesConcernees"
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.informationsNominatives.lblEntreprisesConcernees"
                    )}
                  </Trans>
                }
                multiline
                rows={4}
                onChange={handleOnChange}
                value={decodeHtmlEntities(communication.entreprisesConcernees || '')}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                name="personnesConcernees"
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.informationsNominatives.lblPersonnesConcernees"
                    )}
                  </Trans>
                }
                multiline
                rows={4}
                onChange={handleOnChange}
                value={decodeHtmlEntities(communication.personnesConcernees || '')}
              />
            </FormControl>
            <div className="form-text-label">
              <Trans>
                {t(
                  "formulaireCommunicationRenseignement.renseignements.lblSection"
                )}
              </Trans>
            </div>
            <FormControl fullWidth>
              <TextField required
                name="renseignements"
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.renseignements.lblChampRenseignements"
                    )}
                  </Trans>
                }
                multiline
                rows={12}
                onChange={handleOnChange}
                value={decodeHtmlEntities(communication.renseignements || '')}
                aria-describedby="error-renseignement"
                style={{ backgroundColor: errorRenseignement ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
            </FormControl>
            <div>
              {errorRenseignement && (
                <strong id="error-renseignement" role="alert" className="error">
                  <Trans>{errorRenseignement}</Trans>
                </strong>
              )}
            </div>
            <FormControl fullWidth >
              <TextField
                label={
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.renseignements.lblNumeroAppelOffre"
                    )}
                  </Trans>
                }
                name="numeroAppelOffreContratAvisIntention"
                value={decodeHtmlEntities(communication.numeroAppelOffreContratAvisIntention)}
                onChange={handleOnChange}
              />
            </FormControl>
            <FormControl fullWidth>
              <FormLabel required id="radio-recours-judiciaire-group-label">
                <Trans>
                  {t(
                    "formulaireCommunicationRenseignement.renseignements.lblRenseignementsTransmisAutreOrganisme"
                  )}
                </Trans>
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="radio-renseignements-autre-organisme-group-label"
                name="renseignementsTransmisAutreOrganisme"
                onChange={handleOuiNonQuestionChange}
                aria-describedby="error-renseignement-autre-organisme"
                style={{ backgroundColor: errorRenseignementAutreOrganisme ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              >
                <FormControlLabel value="oui" control={<Radio />} label={<Trans>{t('Oui')}</Trans>} />
                <FormControlLabel value="non" control={<Radio />} label={<Trans>{t('Non')}</Trans>} />
              </RadioGroup>
            </FormControl>
            {errorRenseignementAutreOrganisme && (
              <strong id="error-renseignement-autre-organisme" role="alert" className="error">
                <Trans>{errorRenseignementAutreOrganisme}</Trans>
              </strong>
            )}
            {getChampAutreOrganisme(
              communication.renseignementsTransmisAutreOrganisme || false
            )}
            {communication.renseignementsTransmisAutreOrganisme ? (
              <>
                <FormControl>
                  <FormLabel>
                    <Trans>
                      {t(
                        "formulaireCommunicationRenseignement.renseignements.lblDateTransmissionAutreOrganisme"
                      )}
                    </Trans>
                  </FormLabel>
                  <DatePicker
                    value={communication.dateTransmissionAutreOrganisme !== null ? new Date(communication.dateTransmissionAutreOrganisme) : null}
                    onChange={(value): void => onChangeDateTransmission(value)}
                  />
                </FormControl>
              </>
            ) : null}
            {errorDateTransmission && (
              <div>
                <FormControl>
                  <strong
                    id="error-date-transmission"
                    role="alert"
                    className="error"
                  >
                    <Trans>{errorDateTransmission}</Trans>
                  </strong>
                </FormControl>
              </div>
            )}
            <Paper elevation={2}>
              <FormControl fullWidth>
                <div className="form-attestation">
                  <div className="form-text-label-no-margin">
                    <Trans>{t("attestations.veraciteRenseignement.lbl")}</Trans>
                  </div>
                  <FormControlLabel
                    required
                    control={<Checkbox />}
                    label={
                      <Trans>
                        {t("attestations.veraciteRenseignement.message")}
                      </Trans>
                    }
                    name="attestation"
                    onChange={handleAttestationOnChange}
                    aria-describedby="error-attestation"
                    style={{ backgroundColor: errorAttestation ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                </div>
              </FormControl>
            </Paper>
            {errorAttestation && (
              <strong id="error-attestation" role="alert" className="error">
                <Trans>{errorAttestation}</Trans>
              </strong>
            )}
            {TurnstileWidget()}
            <div>
              <FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={saved}
                >
                  <Trans>
                    {t(
                      "formulaireCommunicationRenseignement.coordonnees.ctaSoumettre"
                    )}
                  </Trans>
                  {loading && (<CircularProgress />)}
                </Button>
              </FormControl>
            </div>
          </Box>
        </CardContent>
      </Card>
    </>
  )
}

export default FormulaireCommunicationRenseignement